// Force scroll to top when page loaded
function preload() {
  window.scrollTo(0, 0)
}

preload()
